import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function initMediaCarousel() {
  const mediaSections = document.querySelectorAll(".media-swiper-wrapper");

  if (!mediaSections.length) return;

  mediaSections.forEach((mediaSection) => {
    const swiperContainer = mediaSection.querySelector(".swiper");
    const progressBar = mediaSection.querySelector(".carousel-progress-bar");
    const nextButton = mediaSection.querySelector(".carousel-button-next");
    const prevButton = mediaSection.querySelector(".carousel-button-prev");
    const carouselControls = mediaSection.querySelector(".carousel-controls");

    if (!swiperContainer || !progressBar) return;

    function updateProgressBar(swiperInstance) {
      if (!progressBar) return;
      const total = swiperInstance.slides.length;
      const perView =
        typeof swiperInstance.params.slidesPerView === "number"
          ? swiperInstance.params.slidesPerView
          : 1;
      const visible = Math.min(perView / total, 1);
      const scrollProgress = Math.min(Math.max(swiperInstance.progress, 0), 1);
      const progress = (visible + scrollProgress * (1 - visible)) * 100;
      progressBar.style.width = `${Math.min(progress, 100)}%`;
    }

    function updateControlsVisibility(swiperInstance) {
      if (!carouselControls) return;
      const slidesPerView = swiperInstance.params.slidesPerView;
      const totalSlides = swiperInstance.slides.length;

      if (totalSlides <= slidesPerView) {
        carouselControls.style.display = "none";
      } else {
        carouselControls.style.display = "";
      }
    }

    function updateContainerPadding(swiperInstance) {
      const slidesPerView = swiperInstance.params.slidesPerView;
      const total = swiperInstance.slides.length;
      if (total <= 3 && slidesPerView === 3) {
        swiperContainer.style.padding = "0 32px";
      } else {
        swiperContainer.style.padding = "";
      }
    }

    const totalSlides =
      swiperContainer.querySelectorAll(".swiper-slide").length;

    new Swiper(swiperContainer, {
      modules: [Navigation],
      slidesPerView: 1.2,
      centeredSlides: false,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      grabCursor: true,
      loop: false,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        init: function () {
          updateProgressBar(this);
          updateControlsVisibility(this);
          updateContainerPadding(this);
        },
        slideChange: function () {
          updateProgressBar(this);
        },
        progress: function () {
          updateProgressBar(this);
        },
        resize: function () {
          updateControlsVisibility(this);
          updateProgressBar(this);
          updateContainerPadding(this);
        },
      },
      breakpoints: {
        744: {
          slidesPerView: 2.2,
          spaceBetween: 24,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
          allowTouchMove: false,
        },
        744: {
          slidesPerView: 2.5,
          spaceBetween: 24,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
          allowTouchMove: false,
        },
        1280: {
          slidesPerView: totalSlides <= 3 ? 3 : 3.2,
          spaceBetween: 32,
          slidesOffsetBefore: totalSlides <= 3 ? 0 : 32,
          slidesOffsetAfter: totalSlides <= 3 ? 0 : 32,
          allowTouchMove: totalSlides > 3,
        },
      },
    });
  });
}
